import { Checkbox, Form, Row } from "antd";
import { useEffect, useState } from "react";
import { GetRegionsList } from "../../API/endpoints/Regions";

interface Props {
  marketSelectionForm: any;
  marketList: any;
  setMarketList: any;
}

const MarketSelection = (props: Props) => {
  const { marketSelectionForm, marketList, setMarketList } = props;

  // const [marketList, setMarketList] = useState([]);

  useEffect(() => {
    GetRegionsList()
      .then((res: any) => {
        setMarketList(res?.data);
      })
      .catch((err: any) => {
        console.error("Something went wrong:", err);
      });
  }, []);

  return (
    <Form
      className="max-w-[400px] "
      layout="vertical"
      form={marketSelectionForm}
    >
      <Form.Item
        name="markets"
        rules={[
          { required: true, message: "Please select at least one market." },
        ]}
      >
        <Checkbox.Group>
          <Row className="gap-y-[28px] ">
            {marketList.map((market: any) => (
              <Checkbox
                key={market.id}
                value={market.id}
                style={{ marginBottom: 12 }}
              >
                {market?.name}
              </Checkbox>
            ))}
          </Row>
        </Checkbox.Group>
      </Form.Item>
    </Form>
  );
};

export default MarketSelection;
